import { styled } from '@linaria/react';

export const Root = styled.svg<{ width?: number }>`
  display: block;
  width: ${({ width }) => width ?? 24}px;
  aspect-ratio: 1;
`;
